import React from 'react';
import PropTypes from 'prop-types';
import BaseActionListItem from './index';
import Title from './title';
import { iconsList } from '../icon/glyphs';

const ActionListLink = ({
  href,
  target = '_self',
  onClick = Function.prototype,
  description = '',
  flagCode = null,
  iconGlyph = null,
  disabled = false,
  selected = false,
  ...otherProps
}) => (
  <BaseActionListItem
    description={description}
    flagCode={flagCode}
    iconGlyph={iconGlyph}
    disabled={disabled}
    selected={selected}
    {...otherProps}
    component={({ children }) => (
      <a className="ws-ui-action-list-link" href={href} target={target} onClick={onClick}>
        <Title>{children}</Title>
      </a>
    )}
  />
);

ActionListLink.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  flagCode: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
};

export default ActionListLink;
